import cancellationPortal from '@cancellation-portal/internationalization/localization-messages/CancellationPortal/en-GB.json';
import cancellationPortalAgencyAgreement from '@cancellation-portal/internationalization/localization-messages/cancellations/cancellation-portal/cancellation-portal-agency-agreement/en-GB.json';

export const enGBTranslations = {
  CancellationPortal: cancellationPortal,
  'cancellations/cancellation-portal/cancellation-portal-agency-agreement': cancellationPortalAgencyAgreement,
};
